import { PrimeFaqKey, PrimeFaqProps } from '@propertypal/shared/src/types/prime';
import React, { useState } from 'react';
import { Heading } from '../../typography';
import PrimeFaq from './PrimeFaq';
import { PrimeFaqContainer, PrimeFaqWrapper } from './PrimeFaq.style';

interface Props extends PrimeFaqProps {
  orders?: boolean;
  agent?: boolean;
}

const PrimeFaqs: React.FC<Props> = ({ allowMultipleExpanded, faqs, orders, agent }) => {
  const [openKeys, setOpenKeys] = useState<PrimeFaqKey[]>(faqs?.filter((faq) => faq.active).map((faq) => faq.id) || []);

  const onToggle = (key: PrimeFaqKey) => {
    setOpenKeys(
      allowMultipleExpanded
        ? openKeys.includes(key)
          ? openKeys.filter((k) => key !== k)
          : [...openKeys, key]
        : openKeys.includes(key)
        ? []
        : [key],
    );
  };

  return (
    <PrimeFaqContainer $orders={orders} $agent={agent}>
      <PrimeFaqWrapper data-testid="prime-faqs">
        <Heading mb={15} fontSize={40}>
          Frequently Asked Questions
        </Heading>
        <div>
          {faqs?.map((faq) => (
            <PrimeFaq {...faq} key={faq.id} toggle={onToggle} open={openKeys.includes(faq.id)} orders={orders} />
          ))}
        </div>
      </PrimeFaqWrapper>
    </PrimeFaqContainer>
  );
};

export default PrimeFaqs;
